<template>
  <td>
    <div v-if="rate.quoted_rate">
      <span v-if="!$auth.isCust()">
        <!-- Subtotal: -->
        {{ subtotal | currency }}

        <span v-if="showDevCosts">
          <!-- System Percentage: -->
          + {{ rate.system_percentage | currency }}

          <!-- System Amount: -->
          + {{ rate.system_amount | currency }}
        </span>

        <span v-if="showTenantCosts">
          <!-- Porcentage Main Admin: -->
          + {{ rate.tenant_percentage | currency }}

          <!-- Monto Main Admin: -->
          + {{ rate.tenant_amount | currency }}
        </span>

        <span v-if="showAdminCosts">
          <!-- Porcentage Admin: -->
          + {{ rate.admin_percentage | currency }}

          <!-- Monto Admin: -->
          + {{ rate.admin_amount | currency }}

          <span v-if="showAdditional">
            <!-- Adicional Tarifas Estaticas: -->
            + {{ rate.additional_static_rate | currency }}
          </span>

          <span>=</span>
        </span>
      </span>

      <b> {{ rate.total | currency }} </b>
    </div>

    <div v-else>
      {{ rate.total | currency }}

      <div v-if="showDiscount && rate.discount > 0">
        <small>{{ $t('attrs.discount') }} {{ rate.discount | currency }}</small>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  name: "RateCostComp",

  data () {
    return {
    }
  },

  props: {
    rate: {
      type: Object,
      required: true
    },

    isOperatorAdminRates: {
      type: Boolean,
      required: true
    },

    showDiscount: {
      type: Boolean,
      required: false
    },
  },

  components: {
  },

  computed: {
    subtotal () {
      if (this.showDevCosts) { return this.rate.subtotal }
      if (this.showTenantCosts) { return this.rate.system_price }
      if (this.showAdminCosts) { return this.rate.tenant_price }

      return 0
    },

    showDevCosts () {
      return this.$auth.isDev()
    },

    showTenantCosts () {
      return this.showDevCosts || this.$auth.isMainAdmin()
    },

    showAdminCosts () {
      return this.showTenantCosts || this.$auth.isAdmin() || (this.$auth.isOper() && this.isOperatorAdminRates)
    },

    showAdditional () {
      return this.rate.static_rate_used && Number(this.rate.additional_static_rate) > 0
    },
  },

  methods: {
  },

  watch: {
  },

  mounted () {
  }
}
</script>
